import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { I18nProvider } from "@/lib/i18n";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";

const shouldEnableVercelTracking = () => {
  if (typeof window === "undefined") return false;

  const { hostname } = window.location;
  return hostname !== "localhost" && hostname !== "127.0.0.1";
};

const App = () => (
  <HelmetProvider>
    <I18nProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        {shouldEnableVercelTracking() ? (
          <>
            <Analytics />
            <SpeedInsights />
          </>
        ) : null}
      </TooltipProvider>
    </I18nProvider>
  </HelmetProvider>
);

export default App;
